<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="printItem" v-for="(item, index) in arr" :key="index">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3" style="width: 100px; border-bottom: none">
              <div :id="'qrCode' + item.employeeNO" align="center" />
            </td>
            <td>编号：{{ item.employeeNO }}</td>
          </tr>
          <tr>
            <td>姓名：{{ item.employeeName }}</td>
          </tr>
          <tr>
            <td>部门：{{ item.departmentName }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      arr: [],
    };
  },

  mounted() {
    this.arr = JSON.parse(this.$route.query.params);
    for (let item of this.arr) {
      this.$nextTick(() => {
        document.getElementById("qrCode" + item.employeeNO).innerHTML = "";
        this.bindQRCode(item.employeeNO);
      });
    }
  },

  methods: {
    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 80,
        height: 80,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 76mm;
  height: 36mm;
  border: 0.5mm solid #666;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    tr {
      td {
        border-bottom: 0.5mm solid #666;
        border-right: 0.5mm solid #666;
        padding: 0 3px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
